import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3100',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function unwrap(response) {
  return response.data.data;
}

export async function login(loginValue, password) {
  const data = unwrap(await api.post('/api/users/login', { login: loginValue, password }));
  localStorage.setItem('auth_token', data.token);
  localStorage.setItem('auth_user', JSON.stringify(data.user));
  return data;
}

export function logout() {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_user');
}
